/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DcRoleDto } from '../../models/dc-role-dto';

export interface GetRoleById$Params {
  id: string;
}

export function getRoleById(http: HttpClient, rootUrl: string, params: GetRoleById$Params, context?: HttpContext): Observable<StrictHttpResponse<DcRoleDto>> {
  const rb = new RequestBuilder(rootUrl, getRoleById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DcRoleDto>;
    })
  );
}

getRoleById.PATH = '/api/roles/{id}';
